module.exports = {
      id: "kuwait-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#kuwait",
      toString: function () {
        return this.url;
      }
    }